const {fr} = require("date-fns/locale");
module.exports = Object.assign({dateFnsLocale: fr}, {
  "chapo_length_number": 559,
  "date_format": {
    "en": "MMMM d yyyy",
    "fr": "d MMMM yyyy"
  },
  "didomi_api_key": "2127e597-3d3f-4aa2-9727-c8126f86298c",
  "v3_share_label": {
    "en": "Share",
    "fr": "Je partage"
  },
  "search_token": "0f9cf61b130ac5c861f09bf6cd8149",
  "notifications_service_endpoint": "https://apim.keolis.com/SIK/000/notification",
  "v3_social_networks": [
    "el5Na9RFTiyBJ3BY8tOv0Q",
    "Lu0AFAbxTM6prGLWYnrN1Q",
    "QSV8oy53SJuCUYSlPdJf6Q",
    "ClP1RWJ4QW-y1obolfiSkg"
  ],
  "site_name": "Keolis.com",
  "serverless_sendmail_endpoint": "https://apim.keolis.com/dato/send/form/instit/",
  "piano_site_id": "639186",
  "notifications_service_import_file_endpoint": "https://apim.keolis.com/SIK/000/file/import HTTP/1.1",
  "hour_format": {
    "en": "HH:mm",
    "fr": "HH:mm"
  },
  "meta_description": {
    "en": "Keolis develops public transport solutions worldwide, and commits to a sustainable and connected mobility.",
    "fr": "Keolis est un opérateur privé de transport public de voyageurs, engagé pour une mobilité durable et connectée."
  },
  "notifications_service_token": "2d5392f4a9404b2690515b92a3eadc93",
  "google_tag_manager_id": "GTM-PX3LLBB",
  "serverless_sendmail_token": "1142321004f3407b98a95856f9820607",
  "facebook_link": "https://www.facebook.com/sharer/sharer.php?u=",
  "twitter_link": "https://twitter.com/intent/tweet?url=",
  "subsidiary_logo": {
    "en": {
      "path": "/46688/1721396559-keolis-2c.svg",
      "format": "svg",
      "size": 1983,
      "alt": "Logo de Keolis en deux couleurs",
      "title": "Keolis 2C",
      "width": 350,
      "height": 90
    },
    "fr": {
      "path": "/46688/1721396559-keolis-2c.svg",
      "format": "svg",
      "size": 1983,
      "alt": "Logo de Keolis en deux couleurs",
      "title": "Keolis 2C",
      "width": 350,
      "height": 90
    }
  },
  "linkedin_link": "https://www.linkedin.com/sharing/share-offsite/?url=",
  "subsidiary_reduced_logo": {
    "en": {
      "path": "/46688/1721396563-logo_k_bleu.svg",
      "format": "svg",
      "size": 639,
      "alt": "Pictogramme du logo Keolis en bleu",
      "title": "Logo K bleu",
      "width": 400,
      "height": 400
    },
    "fr": {
      "path": "/46688/1724157792-logo_k_bleu-size5.svg",
      "format": "svg",
      "size": 754,
      "alt": "Logo Keolis",
      "title": "Keolis",
      "width": 256,
      "height": 256
    }
  },
  "mailto_addresse": "mailto:someone@example.com",
  "home_page_title": {
    "en": "Home",
    "fr": "Accueil"
  },
  "transport_mode_title": {
    "en": "",
    "fr": "Modes de transport"
  },
  "share_buttons_title": {
    "en": "share",
    "fr": "Partager"
  },
  "token_google_site_verification": "google7953ee90b1b2ac4b",
  "facebook_label": {
    "en": "facebook label",
    "fr": "Facebook"
  },
  "twitter_label": {
    "en": "twitter label",
    "fr": "Twitter"
  },
  "linkedin_label": {
    "en": "linkedIn label",
    "fr": "LinkedIn"
  },
  "mailto_label": {
    "en": "mailTo label",
    "fr": "Partager par mail"
  },
  "download_label": {
    "en": "Download",
    "fr": "Télécharger"
  },
  "updated_at": "2025-05-27T18:08:55.415+02:00",
  "created_at": "2021-04-20T17:40:04.593+02:00",
  "locale": "fr",
  "locales": [
    "fr",
    "en"
  ],
  "siteUrl": "https://www.keolis.com/"
})